
import React, { Component } from 'react';
import './selectGroupPage.less';
import group from "../../../imgs/item/group.png";
import { getAllGroupsAndDevices } from '../../../utils/meshUtils';
import { meshLog, SPGet } from '../../../utils/spUtils';
import { getGroupNormalImgWithName } from '../../../utils/fileUtils';
import PubSub from 'pubsub-js'

export default class SelectGroupPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groups: [],
        };
    }

    componentDidMount() {
        this.setState({ groups: getAllGroupsAndDevices() });
        setTimeout(() => {
            if (this.state.groups !== '') {
                this.handleCheckboxChange(1)
            }
        }, 500)
    }

    //多选框
    handleCheckboxChange = (id) => {
        let arr = this.state.groups;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].id == id) {
                arr[i].checked = !arr[i].checked;
            }
        }
        meshLog('wjk 多选框', id);
        meshLog('arr', arr);
        this.setState({ groups: arr });
    };



    sendDataToParent() {
        this.props.onDataToParent("select_group");
    };
    sendDataToParentOK() {
        this.props.onDataToParent("select_group");
        //将选中的组的信息发给log页面和计量电量界面
        meshLog('选中组的信息', this.state.groups);
        PubSub.publish("selectGroupCheckInfo", this.state.groups);
        PubSub.publish("energyManagePage", this.state.groups);
    };


    render() {
        return (
            <div className="groupSelect_container">
                {/* 标题行 */}
                <div className="item_row">
                    <div className="item_title">
                        <img src={group} />
                        <span>Choose Group OTA</span>
                    </div>
                </div>

                {/* group列表 */}
                <div className="group_list">
                    {this.state.groups.map((group) => (
                        <div key={group.id} className="group_item">
                            <img className="group-icon" src={getGroupNormalImgWithName(group.name)} />
                            <span>{group.name}</span>
                            <input className="radioSet" type='checkbox' name='group' value='' checked={group.checked} onChange={() => this.handleCheckboxChange(group.id)} />
                        </div>
                    ))}
                </div>




                {/* 底部按钮 */}
                <div className="groupSelect_footer">
                    <button className='cancelBtn' onClick={this.sendDataToParent.bind(this)}>Cancel</button>
                    <button className='okBtn' onClick={this.sendDataToParentOK.bind(this)}>Confirm</button>
                </div>


            </div>

        );
    }
}
